import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Oferty specjalne',
  view_more: 'Zobacz więcej',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Oferta',
    'FREE ITEM': 'Darmowy produkt',
    REWARDS: 'Nagrody',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} dodatkowych punktów',
      description: 'Oceń nas w Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Oferta specjalna',
      description: 'Już zastosowane automatycznie',
    },
    buttons: {
      add: 'Dodaj',
      remove: 'Usuń',
      show_details: 'Pokaż szczegóły',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} bonus za rejestrację w aplikacji',
      desc: 'Otrzymaj {{amount}} zwrotu po zalogowaniu w aplikacji.',
    },
    welcome_bonus: {
      title: '{{amount}} bonus powitalny',
      desc: 'Otrzymaj {{amount}} zwrotu po rejestracji.',
    },
  },
  discounts: {
    title: 'Rabat {{discount}}',
    usage_threshold: '(Min: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} rabatu na następne zamówienie – kod: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: '{{discount}} rabatu na następne {{count}} zamówienia – kod: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Zaloguj się</highlight>, aby użyć tej promocji i upewnić się, że nie była jeszcze użyta. Zaloguj się i spróbuj ponownie.',
  },
};
